export class UserType {
    userTypeId : string;
    userTypeName : string;
}